var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { RouteFiller } from "../helpers/Helpers";
import { CollaborationServiceSetup } from "../Setup";
export var EventController = {
    /*****************************************************************************************************
        * Is using route "api/event" and http method "POST" to call the back-end.
    
        * @param {EventUploadDto} ev
        * @returns {void}
    ******************************************************************************************************/
    PostEvent: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/event", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.ev
        });
    },
    /*****************************************************************************************************
        * Is using route "api/event/restriction" and http method "POST" to call the back-end.
    
        * @param {EventUploadDto} ev
        * @param {EventCreationRestriction} createRestriction
        * @returns {void}
    ******************************************************************************************************/
    PostEventWithRestriction: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("ev", JSON.stringify(data.ev));
        fd.append("createRestriction", JSON.stringify(data.createRestriction));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/event/restriction", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/event/visibleElements" and http method "POST" to call the back-end.
    
        * @param {VisibleElementsEventUploadDto} ev
        * @returns {void}
    ******************************************************************************************************/
    PostVisibleElementsEvent: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/event/visibleElements", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.ev
        });
    },
    /*****************************************************************************************************
        * Is using route "api/event/appChanged/{newAppType}/{groupId?}" and http method "POST" to call the back-end.
    
        * @param {string} newAppType
        * @param {string} groupId
        * @returns {void}
    ******************************************************************************************************/
    ApplicationChanged: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/event/appChanged/{newAppType}/{groupId?}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/event/{groupid}/{eventTypeStr}" and http method "GET" to call the back-end.
    
        * @param {string} groupid
        * @param {string} eventTypeStr
        * @returns {ExtendedDataCollection<EventDownloadDto, string>}
    ******************************************************************************************************/
    Get: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/event/{groupid}/{eventTypeStr}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
};
/*
$PrintDebugInfo
*/ 
//# sourceMappingURL=EventController.js.map